import React, { useState } from 'react';
// Importamos los componentes que creamos
import AccesoSoloTelefono from './AccesoSoloTelefono';
import StreamPlayer from './StreamPlayer';

function App() {
  // Estado para guardar el usuario una vez que pase la auditoría de Supabase
  const [user, setUser] = useState(null);

  // Función para manejar el éxito del login
  const handleLoginSuccess = (userData) => {
    console.log("Acceso autorizado para:", userData.telefono);
    setUser(userData);
  };

  return (
    <main className="min-h-screen bg-zinc-950">
      {/* LÓGICA DE AUDITORÍA:
          Si no hay usuario (null), mostramos el login por teléfono.
          Si hay usuario, mostramos el reproductor en vivo.
      */}
      {!user ? (
        <AccesoSoloTelefono onLoginSuccess={handleLoginSuccess} />
      ) : (
        <StreamPlayer user={user} />
      )}
    </main>
  );
}

export default App;